import * as React from 'react'
import {FormControl, Theme, createStyles, withStyles, WithStyles, RadioGroup, FormControlLabel, Radio} from '@material-ui/core'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import autobind from 'autobind-decorator'

const styles = (t: Theme) => createStyles({
    formControl: {
        width: '100%'
    },
    radioWpr: {
        flexDirection: "row"
    }
});

interface IProps extends WithI18n,
  WithStyles<typeof styles>{
  input: any;
}


interface IStates {
    optionSelected: any;
}


class YesNoField extends React.Component<IProps, IStates> {
    state = {
        optionSelected: this.generateValue(this.props.input.value),
    };

    render() {
        const {t, classes} = this.props
        return (
            <>
                <FormControl component="fieldset" className={classes.formControl}>
                    <RadioGroup
                        className={classes.radioWpr}
                        value={this.state.optionSelected}
                        onChange={this.handleChange}
                    >
                        <FormControlLabel value="true" control={<Radio />} label={t.yes} />
                        <FormControlLabel value="false" control={<Radio />} label={t.no} />
                    </RadioGroup>
                </FormControl>
            </>
        )
    }

    @autobind
    private generateValue(inputValue: any){
        if(inputValue){
            return inputValue === true ? "true" : "false"
        } else {
            return undefined;
        }
    }


    handleChange = event => {
        this.setState({ optionSelected: event.target.value });
        this.props.input.onChange(event.target.value === "true" ? true : false);
    };

}

export default compose(
  withI18n,
  withStyles(styles)
)(YesNoField)



// WEBPACK FOOTER //
// ./src/shared/form/YesNoField.tsx